import React, { useEffect, useState } from "react";
import useUser from "../../../hooks/useUser";

const SessionLogout = () => {
  const { setToken } = useUser();
  // Read timeout hours from environment and convert to seconds
  const idleHours = parseFloat(process.env.REACT_APP_IDLE_TIMEOUT_HOURS) || 4;
  const timeOutInterval = idleHours * 60 * 60; // hours to seconds
  const [, setTimer] = useState(timeOutInterval);

  useEffect(() => {
    const path = window.location.pathname;

    // 1) Skip timeout logic on live pages
    if (path.startsWith("/live") || path.startsWith("/events/agm-live")) {
      return;
    }

    // 2) Start the countdown
    const myInterval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          setToken("logged_out");
          clearInterval(myInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // 3) Reset on user activity
    const resetTimeout = () => setTimer(timeOutInterval);
    const events = ["mousemove", "mousedown", "click", "scroll", "keypress"];
    events.forEach((e) => window.addEventListener(e, resetTimeout));

    // 4) Cleanup
    return () => {
      clearInterval(myInterval);
      events.forEach((e) => window.removeEventListener(e, resetTimeout));
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // re-run whenever the path changes (so pauses/starts correctly)
    window.location.pathname,
    setToken,
  ]);

  return <React.Fragment>{null}</React.Fragment>;
};

export default SessionLogout;
